import { Link } from 'react-router-dom';

const CARDS = [
  {
    to: '/pages/contact',
    title: 'Contact us',
    text: 'Reach the SkillXzen team with a question about your account or courses.',
  },
  {
    to: '/faq',
    title: 'Help centre',
    text: 'Answers to what learners and organizations ask most.',
  },
  {
    to: '/catalog',
    title: 'Browse courses',
    text: 'See the full catalog, with free previews of selected lessons.',
  },
  {
    to: '/pages/getting-started',
    title: 'Getting started',
    text: 'A four-minute read on getting the most out of your courses.',
  },
];

/**
 * The "Still need help?" strip that closes the help centre and every site
 * page. A card pointing at the page you are already on is left out, and the
 * next one in line takes its place, so there are always three.
 */
export function SupportCards({ current }: { current?: string }) {
  return (
    <section className="helpsupport" aria-label="More help">
      <h2>Still need help?</h2>
      <div className="helpsupport__grid">
        {CARDS.filter((card) => card.to !== current)
          .slice(0, 3)
          .map((card) => (
            <Link className="helpsupport__card" to={card.to} key={card.to}>
              <strong>{card.title}</strong>
              <span>{card.text}</span>
            </Link>
          ))}
      </div>
    </section>
  );
}
